import * as R from 'ramda';
import PRABaseController from './pra.base.controller';

export default function PRAController(
  $filter,
  $location,
  $q,
  $rootScope,
  $scope,
  addPraAssessmentDialog,
  alerts,
  orgDataService,
  praDataService,
  loaderService,
  serviceIds,
  praSettingsDialog,
  ssDialogService,
  userService,
  praSharedModelService,
  riskSharedModelService,
  assetSharedModelService,
) {
  PRABaseController.call(this, userService, loaderService);
  this.initPermissions();
  const vm = this;

  vm.eulaAccepted = true;
  vm.appIsLoaded = false;
  vm.groupId = 41;

  vm.handleShowSettings = handleShowSettings;
  vm.handleShowAddAssessment = handleShowAddAssessment;

  _activate();

  /** **************************************************
   * Event Handlers
   */
  //
  function handleShowSettings($event) {
    loaderService.showViewLoader = true;
    praDataService.getSettings()
      .then((getSettingsResponse) => {
        loaderService.showViewLoader = false;
        ssDialogService.dialogs.pra.settingsDialog = ssDialogService.alert(
          praSettingsDialog.getOptions($event, {
            settings: getSettingsResponse.data,
          })
        );
        loaderService.showViewLoader = false;
        return ssDialogService.show(ssDialogService.dialogs.pra.settingsDialog);
      });
  }

  function handleShowAddAssessment($event) {
    return praDataService.allowNewAssessment().then((isAllowed) => {
      if (!isAllowed.data.result) {
        alerts.warning('Only one active assessment allowed.');
      } else {
        // Display new assessment dialog
        const newAssessment = { assessmentId: 0 };
        ssDialogService.dialogs.pra.addAssessmentDialog = ssDialogService.alert(
          addPraAssessmentDialog.getOptions($event, {
            assessment: newAssessment,
          })
        );
        return ssDialogService.show(ssDialogService.dialogs.pra.addAssessmentDialog);
      }
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _resetInitData();
    return _initPage().then(() => {
      vm.appIsLoaded = true;
      loaderService.showViewLoader = false;
      vm.eulaAccepted = true;
    });
  }

  function _initPage() {
    return $q.all([
      praDataService.initApp(),
      orgDataService.getIsNavantaUser(),
    ]).then((response) => {
      $rootScope.assessmentDepartments = response[0].data.assessmentDepartments.result;
      $rootScope.assessmentFunctions = response[0].data.assessmentFunctions.result;
      $rootScope.assessments = response[0].data.assessments.result;
      praSharedModelService.customerRiskAppetiteLevels = response[0].data.customerRiskAppetiteLevels.result;
      vm.assessments = response[0].data.assessments.result;
      vm.isNavantaUser = response[1].data.result;

      vm.incompleteAssessments = $filter('filter')(
        vm.assessments,
        { approvalDate: null }
      );
      vm.hasIncompleteAssessments = (vm.incompleteAssessments.length > 0);

      vm.completedAssessments = $filter('filter')(
        vm.assessments,
        { approvalDate: '' }
      );
      vm.hasCompletedAssessments = (vm.completedAssessments.length > 0);

      $rootScope.latestCompletedAssessment = $filter('orderBy')(
        vm.completedAssessments,
        'approvalDate',
        true
      )[0];
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshPRAAssessments', _refreshAssessments);
    $scope.$on('refreshStatuses', _refreshStatuses);
  }

  function _refreshAssessments() {
    return _initPage()
      .then((getAssessmentsResponse) => {
        vm.assessments = getAssessmentsResponse.data.result;
        vm.incompleteAssessments = $filter('filter')(
          vm.assessments,
          { approvalDate: null }
        );
        vm.hasIncompleteAssessments = (vm.incompleteAssessments.length > 0);

        vm.completedAssessments = $filter('filter')(
          vm.assessments,
          { approvalDate: '' }
        );
        vm.hasCompletedAssessments = (vm.completedAssessments.length > 0);

        $rootScope.latestCompletedAssessment = $filter('orderBy')(
          vm.completedAssessments,
          'approvalDate',
          true
        )[0];
      });
  }

  function _refreshStatuses() {
    const incompleteAssessment = R.find(
      R.propEq('approvalDate', null),
      vm.assessments
    );
    return praDataService.getAssessmentStatus(
      incompleteAssessment.assessmentId
    ).then((getAssessmentStatusResponse) => {
      incompleteAssessment.status = getAssessmentStatusResponse.data;
      $rootScope.$broadcast(
        'refreshStatusesComplete',
        incompleteAssessment.status
      );
    });
  }

  function _resetInitData() {
    assetSharedModelService.AssetCriticalities = null;
    riskSharedModelService.RiskOnsets = null;
  }
}

PRAController.$inject = [
  '$filter',
  '$location',
  '$q',
  '$rootScope',
  '$scope',
  'addPraAssessmentDialog',
  'alerts',
  'orgDataService',
  'praDataService',
  'loaderService',
  'serviceIds',
  'praSettingsDialog',
  'ssDialogService',
  'userService',
  'praSharedModelService',
  'riskSharedModelService',
  'assetSharedModelService',
];
